import React from 'react';

const LiveStatsHeader = ({ 
  tournament, 
  currentRound, 
  currentHole, 
  totalSkins, 
  totalSawoffs,
  totalSkinsCompletedAndCurrent = 0,
  totalSawoffsCompletedAndCurrent = 0,
  players = []
}) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Use the totals passed from parent component
  const totals = {
    totalSkinsCompleted: totalSkins || 0,
    totalSawoffsCompleted: totalSawoffs || 0,
    totalSkinsCompletedAndCurrent: totalSkinsCompletedAndCurrent || 0,
    totalSawoffsCompletedAndCurrent: totalSawoffsCompletedAndCurrent || 0
  };

  return (
    <div className="live-stats-header">
      <div className="tournament-info">
        <h4 className="tournament-name">{tournament.name}</h4>
        <div className="tournament-meta">
          <span className={`tournament-status ${tournament.status.toLowerCase()}`}>
            {tournament.status}
          </span>
          <span className="tournament-pot">
            Pot: {formatCurrency(tournament.potSize || 0)}
          </span>
        </div>
      </div>

      <div className="live-stats-grid">
        <div className="stats-row">
          <div className="stat-item">
            <div className="stat-label">Total Skins</div>
            <div className="stat-value skins">{totals.totalSkinsCompleted}</div>
          </div>
          
          <div className="stat-item">
            <div className="stat-label">Total Sawoffs</div>
            <div className="stat-value sawoffs">{totals.totalSawoffsCompleted}</div>
          </div>
        </div>

        <div className="stats-row">
          <div className="stat-item">
            <div className="stat-label">Total Skins*</div>
            <div className="stat-value skins">{totals.totalSkinsCompletedAndCurrent}</div>
          </div>
          
          <div className="stat-item">
            <div className="stat-label">Total Sawoffs*</div>
            <div className="stat-value sawoffs">{totals.totalSawoffsCompletedAndCurrent}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveStatsHeader;
